import React, { useState } from "react";
import PropTypes from "prop-types";
// ui
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
// style
import { createStyles, makeStyles, styled } from "@material-ui/styles";
// components
import TemplateHome from "../components/TemplateHome";

// utils

//
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

//
const ShopPage = () => {
  // style
  const classes = useStyles();
  // props

  // local state

  return (
    <TemplateHome>
      <Grid container justifyContent="center">
        <Grid item>
          <Box pt={5}>
            <Typography variant="h5">ShopPage</Typography>
          </Box>
        </Grid>
      </Grid>
    </TemplateHome>
  );
};

ShopPage.propTypes = {};

ShopPage.defaultProps = {};

export default ShopPage;
